import React from 'react'
import { PanInfo, AnimationControls } from 'framer-motion'

import { CardTitle } from '../../../views/Quiz/components/QuestionCards/styled'

import { Question, ImageWrap, Illustration } from './styled'
import { determineSwipeEmotion } from './utils'

import { IQuizQuestion, ActionAnswer } from 'src/api/quizzes/types'
import { CardHint } from 'src/components/Typography'
import { useMedia } from 'src/hooks/useMedia'
import { breakpoints } from 'src/styles/media'

interface Props {
  question: IQuizQuestion
  setFaceEmotion: (emotion?: ActionAnswer) => void
  faceEmotion?: ActionAnswer
  animation?: AnimationControls
  answerQuestion: (answer: ActionAnswer) => void
  dragEnabled: boolean
}

export const QuestionCard: React.FC<Props> = ({
  question: { colors, title, imageUrl },
  setFaceEmotion,
  faceEmotion,
  animation,
  answerQuestion,
  dragEnabled,
}) => {
  const [isTapped, setIsTapped] = React.useState(false)

  const isDesktop = useMedia(breakpoints.desktop)

  const handleDoubleTap = async () => {
    if (isTapped) {
      answerQuestion(ActionAnswer.skip)
    }
    setIsTapped(true)
    setTimeout(() => {
      setIsTapped(false)
    }, 250)
  }

  const handlePan = (
    _: MouseEvent | TouchEvent | PointerEvent,
    { offset }: PanInfo
  ) => {
    const newEmotion = determineSwipeEmotion(offset)
    if (newEmotion !== faceEmotion) {
      setFaceEmotion(newEmotion)
    }
  }

  const handlePanEnd = async (
    _: MouseEvent | TouchEvent | PointerEvent,
    { offset }: PanInfo
  ) => {
    const answer = determineSwipeEmotion(offset)

    if (answer) {
      answerQuestion(answer)
    }
  }

  return (
    <Question
      drag={dragEnabled}
      bgStart={colors.bgStart}
      bgEnd={colors.bgEnd}
      dragConstraints={{ top: 0, left: 0, bottom: 0, right: 0 }}
      onDrag={handlePan}
      onDragEnd={handlePanEnd}
      animate={animation}
      transition={{ duration: 1, delay: isDesktop ? 0.3 : 0 }}
      onTap={handleDoubleTap}
    >
      <ImageWrap>
        <Illustration src={imageUrl} draggable={false} />
      </ImageWrap>
      <div>
        <CardHint>do you like</CardHint>
        <CardTitle color={colors.text}>{title}</CardTitle>
      </div>
    </Question>
  )
}
